import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-logout-modal',
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.scss']
})
export class LogoutModalComponent implements OnInit {

  constructor(public bsModalRef: BsModalRef, private storage: StorageService, private authService: AuthenticationService) { }

  ngOnInit() {
  }

  logout() {
   this.storage.removeLocalValue('selectedAssignedAgentUserName');
   this.storage.removeLocalValue('selectedAssignedAgentLastName');
   this.storage.removeLocalValue('selectedAssignedAgentFirstName');
   this.authService.logout();
   this.bsModalRef.hide();
  }

}
